var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg102(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "104") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-night",
    transform: "translate(-206.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 104,
    transform: "translate(208.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48311688,-1.42108547e-14 C8.93746523,-1.42108547e-14 11.0732337,1.36378252 12.1739756,3.37490093 C10.3450064,4.91579088 9.12160498,7.15142258 8.90969766,9.67480519 L8.90969766,9.67480519 L8.37848104,9.67480519 C6.33728496,9.67480519 4.52756557,10.6631654 3.40140183,12.1872963 C1.3755217,11.0915727 -7.10542736e-14,8.94800587 -7.10542736e-14,6.48311688 C-7.10542736e-14,2.9025413 2.9025413,-1.42108547e-14 6.48311688,-1.42108547e-14 Z",
    id: "Combined-Shape",
    fill: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1398608,2.69298701 C21.4578203,2.69298701 24.3765195,4.79212052 25.464586,7.86920727 L25.464586,7.86920727 L25.8790068,9.04095584 L27.1068094,8.84845714 C27.4088229,8.80108052 27.7161226,8.77714286 28.027013,8.77714286 C31.2770494,8.77714286 33.9116883,11.4117818 33.9116883,14.6618182 C33.9116883,17.9118545 31.2770494,20.5464935 28.027013,20.5464935 L28.027013,20.5464935 L8.37848104,20.5464935 C5.78892468,20.5464935 3.69038961,18.4481579 3.69038961,15.8587013 C3.69038961,13.2694442 5.78882494,11.1709091 8.37848104,11.1709091 L8.37848104,11.1709091 L10.2854151,11.1709091 L10.4006151,9.79997922 C10.7367397,5.79720312 14.0960914,2.69298701 18.139761,2.69298701 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg102);
export default __webpack_public_path__ + "static/media/102.59af43ced71b0b0fbd3e8a3546d5e3d0.svg";
export { ForwardRef as ReactComponent };